import { Box, CardActionArea, Divider, Stack, Typography } from "@mui/material"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { UserContext } from "../../contexts/UserContext"

const Driver = () => {
    const { t } = useTranslation()
    const context = useContext(UserContext)

    // Handle context missing
    if (!context) {
        throw new Error("UserContext is not provided")
    }
    const { user } = context

    return (
        <Box
            width="100%"
            paddingTop="3vh" // Adjusting top padding for better alignment
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{ height: "100vh" }} // Dark background for contrast
        >
            <Stack sx={{ pl: 1, pr: 3, width: "90%" }} spacing={4}>
                <Typography
                    color="text.primary"
                    variant="h6"
                    sx={{
                        textAlign: "center",
                        mb: 3,
                    }}
                >
                    {t("drivers.mobile.title")}
                </Typography>
                <Box
                    sx={{
                        width: "100%",
                        marginTop: { xs: 3, sm: 4, md: 5 },
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "right",
                    }}
                >
                    <Box
                        width="100%"
                        display="flex"
                        flexDirection="row"
                        borderRadius={5}
                        sx={{ bgcolor: "primary.main" }} // Assign color based on index
                        p={2}
                    >
                        <Box width="90%" position="relative" marginY={1}>
                            <CardActionArea>
                                <Box padding={2}>
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            color="white"
                                            sx={{ fontWeight: "medium", fontSize: "1.1rem" }}
                                        >
                                            {user?.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t("sites.mobile.totalSites", { totalSites: user?.sites?.length })}
                                        </Typography>
                                    </Box>
                                    <Divider
                                        sx={{
                                            width: "20%",
                                            borderStyle: "solid",
                                            marginTop: "6%",
                                            marginBottom: "6%",
                                            borderColor: "white",
                                        }}
                                    />
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            color="white"
                                            sx={{ fontWeight: "medium", fontSize: "1.1rem" }}
                                        >
                                            {user?.email}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t("shifts.mobile.totalShifts", { totalShifts: user?.shifts?.length })}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardActionArea>
                        </Box>
                    </Box>
                </Box>
                <Typography sx={{ mt: 2 }} variant="body2">
                    {t("drivers.mobile.details.applicationPwaVersion")}
                </Typography>
            </Stack>
        </Box>
    )
}

export default Driver
